import { render, staticRenderFns } from "./ruleTemp.vue?vue&type=template&id=cbb2c596&scoped=true"
import script from "./ruleTemp.vue?vue&type=script&lang=js"
export * from "./ruleTemp.vue?vue&type=script&lang=js"
import style0 from "./ruleTemp.vue?vue&type=style&index=0&id=cbb2c596&prod&lang=css"
import style1 from "./ruleTemp.vue?vue&type=style&index=1&id=cbb2c596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb2c596",
  null
  
)

export default component.exports